<template>
    <div class="has-text-centered">
        <LoadingButton
            :class="{'slightly-rounded': roundedEdges}"
            :text="text"
            :loading="loading"
            bulma-color-class="is-danger"
            bulma-icon="fa-trash"
            @clicked="deleteClicked">
        </LoadingButton>
    </div>
</template>

<script>
    import { deleteSound } from '@/js/apis'
    import LoadingButton from '@/widgets/LoadingButton.vue'

    export default {
        name: 'DeleteFilesButton',
        components: {LoadingButton},
        props: {
            filesToDelete: {type: Array, default: []},
            onlyIcon: {type: Boolean, default: false, required: false},
            roundedEdges: {type: Boolean, default: false, required: false},
            requestingUser: {type: String, default: "", required: true},
        },
        emits: ['filesDeleted'],
        data(){
            return {
                loading: false,
            }
        },
        computed: {
            text(){
                // calculate whether to only show the icon, or also the text
                return this.onlyIcon ? '' : 'Delete Files'
            },
        },
        methods: {
            async deleteClicked(){
                // Check if the user really wants to delete the files
                const confirmDelete = window.confirm('Are you sure you want to delete the chosen file(s)?')
                if (confirmDelete) {
                    try {
                        this.loading = true
                        let promises = []
                        for (const fileId of this.filesToDelete){
                            promises.push(deleteSound(this.requestingUser, fileId))
                        }
                        let responses = await Promise.all(promises)

                        this.$emit('filesDeleted', responses)
                        this.loading = false
                    }
                    catch {
                        (error) => {
                            console.error('an error has occurred', error)
                        }
                    }
                }
            }
        },
    }
</script>

